import { Card } from "reactstrap";
import FollowerChart from "./FollowerChart";
import CommonHeaderWithDropDown from "../TotalUserAndFollower/common/CommonHeaderWithDropDown";
import { FollowersGrowth, WeeklyMonDropdown } from "../../../../Constant";

const FollowerGrowth = () => {
  return (
    <Card className="growth-wrap">
      <CommonHeaderWithDropDown headerClassName="pb-0" dropDownIcon={true} heading={FollowersGrowth} dropDownList={WeeklyMonDropdown} caret={false} dropDownToggleClassName="dropdown-toggle" dropDownClass="dropdown icon-dropdown"/>
      <FollowerChart />
    </Card>
  );
};

export default FollowerGrowth;
